import {useQuery} from '@tanstack/react-query';
import Cookies from 'js-cookie';

import * as bffSupportQueries from '@/modules/common/queries/bffSupport';

export const useUserCity = (): string | null => {
  const metaQuery = useQuery(bffSupportQueries.meta());
  if (metaQuery.isPending) {
    return null;
  }
  return metaQuery.data?.userCity ?? 'Unknown';
};

export const useSessionChurnRisk = ({
  enabled,
}: {
  enabled: boolean;
}): number | null => {
  const BD4ID = Cookies.get('bd4ti') ?? '';
  const smartseerProfileQuery = useQuery({
    ...bffSupportQueries.smartseerProfile({BD4ID}),
    enabled: enabled && Boolean(BD4ID),
    retry: false,
    refetchOnWindowFocus: false,
  });
  // @TODO not sure about this... check again
  if (enabled && Boolean(BD4ID) && smartseerProfileQuery.isPending) {
    return null;
  }
  return smartseerProfileQuery.data?.intent?.sessionChurnRisk ?? -1;
};

export const getForcedTreatmentForTesting = () => {
  const localStorageItem = localStorage.getItem(
    'forceExperimentationExitIntentLayer'
  );
  if (
    localStorageItem === 'Default' ||
    localStorageItem === 'Leipzig' ||
    localStorageItem === 'NotLeipzig' ||
    localStorageItem === 'Picture'
  ) {
    return localStorageItem;
  }
  return null;
};
